import { BuyBackWrapper } from '../features/buy-back/components/buy-back-wrapper'

export const BuyBackHoldersPage: React.FC = () => {
  // TODO: Implement holders page when BE ready
  return <BuyBackWrapper>IN PROGRESS</BuyBackWrapper>
}
